function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVeepeeinline = function SvgVeepeeinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 117.684,
    height: 48.2,
    style: {
      clipRule: "evenodd",
      fillRule: "evenodd",
      imageRendering: "optimizeQuality",
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision"
    }
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#ea0389",
    d: "M374.5-.5h4c6.933 5.098 13.1 11.098 18.5 18a94.606 94.606 0 0 1 11-12c3.393 5.372 5.893 11.038 7.5 17v21c-1.375 5.444-3.375 10.778-6 16 1.72.246 3.72.246 6 0v6c-8.889 11.304-20.222 19.47-34 24.5-14.423 6.024-29.423 9.024-45 9a413.281 413.281 0 0 0 38-12c12.659-5.335 20.159-14.835 22.5-28.5 1.901-13.285-1.099-25.285-9-36a97.326 97.326 0 0 0-9.5-7c-6.962 10.388-10.628 21.888-11 34.5.665 5.482.998 10.982 1 16.5-11.069.077-18.069 5.41-21 16a28.966 28.966 0 0 0 3 8c-.502 1.021-1.168 1.188-2 .5-4.878-6.183-6.044-13.017-3.5-20.5 4.342-5.755 10.175-8.755 17.5-9-5.031-22.49-1.031-43.157 12-62m32 19c5.397 14.498 4.563 28.831-2.5 43 2.371-11.845 1.538-23.511-2.5-35 1.177-3.031 2.844-5.698 5-8",
    style: {
      opacity: 0.836
    },
    transform: "matrix(.2829 0 0 .39835 .141 .2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#22201f",
    d: "M-.5 33.5c3.937-.293 7.77.04 11.5 1a908.93 908.93 0 0 0 25.5 51l25.5-51c3.73-.96 7.563-1.293 11.5-1a978.004 978.004 0 0 1-32 65c-3.545 1.291-7.045 1.291-10.5 0a2692.711 2692.711 0 0 0-31.5-62z",
    style: {
      opacity: 0.871
    },
    transform: "matrix(.2829 0 0 .39835 .141 .2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#22201f",
    d: "M76.5 55.5c6.675-.166 13.342 0 20 .5 6.4 1.4 10.566 5.233 12.5 11.5a49.557 49.557 0 0 1 1.5 13c-12.671-.167-25.338 0-38 .5.415 3.505 2.081 6.172 5 8 10.268 1.4 20.602 1.9 31 1.5v9c-10.006.166-20.006 0-30-.5-8.274-.94-13.44-5.44-15.5-13.5-1.356-8.028-.356-15.695 3-23 2.998-3.238 6.498-5.571 10.5-7m4 9a45.882 45.882 0 0 1 15 1.5 14.505 14.505 0 0 1 4 5c-8.686.832-17.352.665-26-.5 1.392-3.183 3.725-5.183 7-6",
    style: {
      opacity: 0.899
    },
    transform: "matrix(.2829 0 0 .39835 .141 .2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#22201f",
    d: "M130.5 55.5c6.342-.166 12.675 0 19 .5 7.348 1.09 11.848 5.258 13.5 12.5.642 3.99 1.142 7.99 1.5 12h-38c-.089 3.933 1.578 6.766 5 8.5a167.908 167.908 0 0 0 30 1.5v9c-10.006.167-20.006 0-30-.5-10.77-3.013-16.103-10.18-16-21.5-.39-11.238 4.61-18.572 15-22m3 9a51.29 51.29 0 0 1 16 1.5c2.107 1.264 3.107 3.097 3 5.5-8.36.331-16.693-.002-25-1 1.077-3.077 3.077-5.077 6-6",
    style: {
      opacity: 0.905
    },
    transform: "matrix(.2829 0 0 .39835 .141 .2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#22201f",
    d: "M180.5 120.5h-11c-.167-16.337 0-32.67.5-49 .453-7.083 3.953-11.917 10.5-14.5 9.653-1.97 19.32-1.97 29 0 5.338 2.007 8.504 5.84 9.5 11.5.667 6 .667 12 0 18-1.333 5.844-4.833 9.678-10.5 11.5-9.257 2.143-18.424 1.976-27.5-.5-.5 7.659-.666 15.326-.5 23m7-56c5.011-.166 10.011 0 15 .5 5.632 1.914 7.965 5.914 7 12 .723 10.25-4.11 14.75-14.5 13.5-4.609.013-8.942-.987-13-3-1.576-5.888-1.909-11.888-1-18 1.563-2.523 3.73-4.19 6.5-5",
    style: {
      opacity: 0.893
    },
    transform: "matrix(.2829 0 0 .39835 .141 .2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#22201f",
    d: "M239.5 55.5c6.675-.166 13.342 0 20 .5 7.167 1.833 11.667 6.333 13.5 13.5a60.93 60.93 0 0 1 .5 11h-37c-.154 3.525 1.179 6.359 4 8.5a184.542 184.542 0 0 0 31 1.5v9c-10.006.167-20.006 0-30-.5-8.833-1.5-14-6.667-15.5-15.5-1.796-9.32.37-17.486 6.5-24.5zm4 9c5.902-.538 11.568.295 17 2.5a18.083 18.083 0 0 1 2 3.5 113.225 113.225 0 0 1-26 .5c1.601-3.107 3.935-5.273 7-6.5M293.5 55.5c6.342-.166 12.675 0 19 .5 6.794 1.146 11.294 4.98 13.5 11.5a49.557 49.557 0 0 1 1.5 13c-12.684-.332-25.351 0-38 1 .566 3.317 2.233 5.817 5 7.5 10.268 1.4 20.602 1.9 31 1.5v9c-10.339.167-20.672 0-31-.5-7.728-1.395-12.562-5.895-14.5-13.5-1.356-8.028-.356-15.695 3-23 2.998-3.238 6.498-5.571 10.5-7m3 9a51.29 51.29 0 0 1 16 1.5 14.506 14.506 0 0 1 4 5c-8.686.832-17.353.665-26-.5 1.174-2.903 3.174-4.903 6-6",
    style: {
      opacity: 0.9
    },
    transform: "matrix(.2829 0 0 .39835 .141 .2)"
  }));
};
export default SvgVeepeeinline;